import React, { useEffect, Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
// Lazy load pages for code splitting and faster initial load
const ReviewPage = lazy(() => import('./pages/ReviewPage').then(module => ({
  default: module.ReviewPage
})));
const HomePage = lazy(() => import('./pages/HomePage').then(module => ({
  default: module.HomePage
})));
const ImpressumPage = lazy(() => import('./pages/ImpressumPage').then(module => ({
  default: module.ImpressumPage
})));
const DatenschutzPage = lazy(() => import('./pages/DatenschutzPage').then(module => ({
  default: module.DatenschutzPage
})));
// Loading fallback component
function LoadingFallback() {
  return <div className="min-h-screen bg-white flex items-center justify-center" data-id="element-0">
      <div className="text-slate-400" data-id="element-1">Lädt...</div>
    </div>;
}
// Scroll to top on route change
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
function AppRoutes() {
  return <>
      <ScrollToTop data-id="element-2" />
      <Suspense fallback={<LoadingFallback data-id="element-4" />} data-id="element-3">
        <Routes data-id="element-5">
          <Route path="/" element={<HomePage data-id="element-7" />} data-id="element-6" />
          <Route path="/reviews/crm-kraft" element={<ReviewPage data-id="element-9" />} data-id="element-8" />
          <Route path="/impressum" element={<ImpressumPage data-id="element-11" />} data-id="element-10" />
          <Route path="/datenschutz" element={<DatenschutzPage data-id="element-13" />} data-id="element-12" />
        </Routes>
      </Suspense>
    </>;
}
export function App() {
  return <HelmetProvider data-id="element-14">
      <Router data-id="element-15">
        <AppRoutes data-id="element-16" />
      </Router>
    </HelmetProvider>;
}